import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_022",
  "use": "icon-su_022-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-su_022\"><defs><style>#icon-su_022 .cls-1{fill:#ccccd0;}</style></defs><g id=\"icon-su_022_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_022_icon\"><path class=\"cls-1\" d=\"M8,1A7,7,0,1,1,1,8,7,7,0,0,1,8,1M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z\" /><polygon class=\"cls-2\" points=\"11.41 8 6.71 12.71 5.29 11.29 8.59 8 5.29 4.71 6.71 3.29 11.41 8\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol